import { Stack } from '@fluentui/react';
import React from 'react';
import { RemoteMessage, UserMessage } from './components';
import axios from 'axios';
import { Input } from './components';
import { HISTORY_API } from './config';
import { OnSubmitHistory, StateType } from './FlowRunner';

export interface HistoryResponse {
  history: Array<{
    id: number;
    stateName: string;
    stateType: StateType;
    stateMessage: string;
    createdAt: string;
  }>;
  inputs: Array<{
    id: number;
    inputState: string;
    data: Array<Input>;
    createdAt: string;
  }>;
}

export const HistoryRenderer = (props: {
  logo?: string;
  history: HistoryResponse['history'];
  remoteMessages: { [k: string]: string | JSX.Element };
}): JSX.Element => {
  const { logo, history, remoteMessages } = props;

  console.log('HistoryRenderer', history);

  const Components: Array<JSX.Element> = [];

  // IMPORTANT: We don't render the last entry in the history and let flow runner render it.
  for (let i = 0; i < history.length - 1; i++) {
    const entry = history[i];
    if (entry.stateType === 'remote_input' && remoteMessages[entry.stateName]) {
      Components.push(
        <Stack key={entry.id}>
          <RemoteMessage
            text={remoteMessages[entry.stateName]}
            {...(logo ? { logo } : {})}
          />
          <br />
        </Stack>
      );
    } else if (entry.stateType === 'success_message') {
      Components.push(
        <Stack key={entry.id} horizontalAlign="end" styles={{ root: { marginBottom: '1rem' } }}>
          <UserMessage text={entry.stateMessage} />
          <br />
        </Stack>
      );
    } else if (entry.stateType === 'custom_element') {
      Components.push(
        <Stack key={entry.id}>
          {remoteMessages[entry.stateName]}
          <br />
        </Stack>
      );
    }
  }

  return <>{Components}</>;
};

export const loadHistory = async (): Promise<HistoryResponse> => {
  const response = await axios.get(HISTORY_API);
  return response.data;
};

export const syncHistory: OnSubmitHistory = async (data) => {
  try {
    await axios.post(HISTORY_API, data);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log('Error', error.response?.data);
    }
    throw error;
  }
};
